// Verify a newly issued credential before publishing identity or redirecting.
// Explicit Bearer prevents adopting an old cookie/storage identity on failure.
export async function verifyLoginSession(client, loginResponse) {
  const token = loginResponse?.session_token;
  if (typeof token !== "string" || !token.trim()) throw new Error("Invalid login response");
  const response = await client.get("/auth/me", {
    headers: { Authorization: `Bearer ${token}` },
    sessionCredential: token,
    timeout: 10000,
  });
  const user = response.data;
  if (!user?.user_id || (loginResponse.user?.user_id && loginResponse.user.user_id !== user.user_id)) {
    throw new Error("Session identity mismatch");
  }
  return { user, token };
}